import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../styles/pages.css";
import DOMPurify from "dompurify";
import { getNotice } from "../../api";

const BoardDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [notice, setNotice] = useState(null);
  const [error, setError] = useState(null);

  // HTML을 안전하게 정제하는 함수
  const sanitizeContent = (content) => {
    return DOMPurify.sanitize(content, {
      ADD_TAGS: ["iframe"], // 기본적으로 iframe은 제거되므로 허용해줍니다
      ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling"], // iframe 관련 속성 허용
    });
  };

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const res = await getNotice({id: id});
        const data = res.data;
        setNotice(data);
      } catch (e) {
        setError(e);
        setNotice(null);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  const handleBackToList = () => {
    navigate("/board/notice");
  };

  const handleDownload = async (file) => {
    try {
      if (!file || !file.url) {
        alert('다운로드할 수 없는 파일입니다.');
        return;
      }
      const response = await fetch(file.url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = file.name || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('다운로드 오류:', error);
      alert('다운로드 중 오류가 발생했습니다.');
    }
  };

  if (loading) {
    return <div className="loading">로딩 중...</div>;
  }

  if (error) return <div className="not-found">불러오는 중 오류가 발생했습니다.</div>;
  
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}.${month}.${day}`;
  };

  return (
    <div className="notice-detail-container">
      <div className="notice-detail-content">
        <h1 className="notice-detail-title">{notice.title}</h1>
        <div className="notice-detail-date">{formatDate(notice.created_at)}</div>
        <hr />
        {notice.attachments && notice.attachments.length > 0 && (
          <div className="notice-attachments">
            {notice.attachments.map((attachment, index) => (
              <div key={index} className="attachment-item" onClick={() => handleDownload(attachment.file)}>
                <div className="attachment-icon">
                  {attachment.file.type === "image" ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#666" viewBox="0 0 16 16">
                      <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
                      <path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2zM14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1zM2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1h-10z" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#666" viewBox="0 0 16 16">
                      <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
                    </svg>
                  )}
                </div>
                <span className="attachment-name">{attachment.file.name}</span>
              </div>
            ))}
          </div>
        )}

        <div className="notice-content" dangerouslySetInnerHTML={{ __html: notice ? sanitizeContent(notice.notice_content) : "" }} />
        <div className="notice-list-button-container">
          <button className="notice-list-button" onClick={handleBackToList}>
            목록으로
            <svg className="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="74.318" height="9.143" viewBox="0 0 74.318 9.143">
              <path data-name="패스 17" d="M7734.385 1613.134h72.855l-10.653-8.248" transform="translate(-7734.385 -1604.491)" style={{ fill: "none", stroke: "currentColor" }} />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BoardDetail;
